import { useAPI } from '../../state';
import { UIConfigData } from './interface';

// API endpoint constants
const UI_CONFIG_UPDATE_API = '/api/v1/ui-configs/columns';
const UI_CONFIG_FILTER_API = '/api/v1/ui-configs/filters';
const UI_CONFIG_RESET_FILTER_API = '/api/v1/ui-configs/filters/reset';
const UI_CONFIG_FILTER_OPTIONS_API =
  '/api/v1/ui-configs/filters?configType={type}';
const UI_CONFIG_TYPE_API = '/api/v1/ui-configs/{type}';

/**
 * Hook for fetching UI configuration data by type
 * @param type - The UI configuration type to fetch
 * @returns [data, fetchFunction, clearFunction]
 */
export const useUIConfigAPI = (type?: string) => {
  return useAPI<UIConfigData>(UI_CONFIG_TYPE_API, { type });
};

/**
 * Hook for updating UI column configurations
 * @returns [response, updateFunction, clearFunction]
 */
export const useUpdateUIConfigAPI = () => {
  return useAPI(UI_CONFIG_UPDATE_API, {}, 'PUT');
};

/**
 * Hook for resetting UI filter configurations
 * @returns [response, resetFunction, clearFunction]
 */
export const useResetUIConfigAPI = () => {
  return useAPI<UIConfigData>(UI_CONFIG_RESET_FILTER_API, {}, 'PUT');
};

/**
 * Hook for fetching filter options for dynamic filters
 * @returns [data, fetchFunction, clearFunction]
 */
export const useGetFilterOptionsAPI = () => {
  return useAPI(UI_CONFIG_FILTER_OPTIONS_API, {}, 'GET');
};

/**
 * Hook for updating UI filter configurations
 * @param type - The UI configuration type to update
 * @returns [response, updateFunction, clearFunction]
 */
export const useUpdateConfigFilterAPI = () => {
  return useAPI<UIConfigData>(UI_CONFIG_FILTER_API, {}, 'PUT');
};
